
import chinamobile from './brands/chinamobile'
import hla from './brands/hla'
import mazda from './brands/mazda'
import mengniu from './brands/mengniu'
import suning from './brands/suning'

import migu from './brands/migu'
import bosch from './brands/bosch'
import yanghe from './brands/yanghe'
import zedriv from './brands/zedriv'
import herborist from './brands/herborist'

import illumcare from './brands/illumcare'
import illuma from './brands/illuma'
import tommee from './brands/tommee'
import vanke from './brands/vanke'
import yincheng from './brands/yincheng'

import vive from './brands/vive'
import maxam from './brands/maxam'
import tetra from './brands/tetra'
import avic from './brands/avic'
import hpnk from './brands/hpnk'

let brands = {

  chinamobile,
  hla,
  mazda,
  mengniu,
  suning,

  migu,
  bosch,
  yanghe,
  zedriv,
  herborist,

  illumcare,
  illuma,
  tommee,
  vanke,
  yincheng,

  vive,
  maxam,
  tetra,
  avic,
  hpnk

}

export default brands
